import {
    map as _map,
    keyBy as _keyBy,
    some as _some,
} from 'lodash';

import { logger } from '@app/logger';
import { WithdrawalType } from '@core/models/user/enums';

import {
    WithdrawalFeesDto,
    PaymentMethod,
} from './dtos/WithdrawalFeesDto';
import {
    WithdrawalFees,
    WithdrawalFeeEntry,
    FeeType,
} from '../../models/user/withdrawal/WithdrawalFees';
import {
    fillToUTCDate,
    toDate,
} from '@superbet-group/web.lib.utilities';

export function transformWidthrawalFees(dto: WithdrawalFeesDto) {
    const fees = mapSettings(dto.WithdrawalFeesSettings);
    const hasFees = _some(fees, (fee) => fee.feeAmount > 0);
    const withdrawalFees: WithdrawalFees = {
        withdrawalFeeEnabled: dto.WithdrawalFeeEnabled && hasFees,
        withdrawalFeeEndPeriod: dto.WithdrawalFeeEndPeriod ? toDate(fillToUTCDate(dto.WithdrawalFeeEndPeriod)) : null,
        withdrawalFeesSettings: fees,
        freeWithdrawalsLeft: Math.max(dto.FreeWithdrawalFeesInPeriod - (dto.WithdrawalsFeesCount || 0), 0),
    };
    return withdrawalFees;
}

// eslint-disable-next-line class-methods-use-this
function mapSettings(dto: WithdrawalFeesDto['WithdrawalFeesSettings']) {
    const settingsFlat: (WithdrawalFeeEntry | null)[] = _map(dto, ({
        FeeAmount: feeAmount,
        FeeType: feeType,
        PaymentMethod: paymentMethod,
    }) => {
        try {
            return ({
                feeAmount,
                feeType,
                paymentMethod: paymentMethod === PaymentMethod.Agency ? WithdrawalType.Shop : (`${paymentMethod.charAt(0).toLowerCase()}${paymentMethod.slice(1)}` as WithdrawalType),
            });
        } catch (e) {
            logger.error(new Error(`Fee mapping error. Payment method ${paymentMethod}`));
            return null;
        }
    });
    const settingsMap = _keyBy(settingsFlat.filter(Boolean), 'paymentMethod') as any as WithdrawalFees['withdrawalFeesSettings'];
    // fill missing
    Object.values(WithdrawalType).forEach((type) => {
        settingsMap[type] = settingsMap[type] || {
            feeAmount: 0,
            feeType: FeeType.FixedAmount,
        };
    });
    return settingsMap;
}
